import './App.css';
import About from "./components/about/About.jsx";
import Contact from "./components/contact/Contact.jsx";
import Footer from "./components/footer/Footer.jsx";
import Header from './components/header/Header.jsx';
import Home from "./components/home/Home.jsx";
import Qualifications from "./components/qualifications/Qualifications.jsx";
import Scroll from "./components/scroll/ScrollToTop.jsx";
import Skills from "./components/skills/Skills.jsx";
import Projects from "./components/projects/Projects.jsx";
import Articles from "./components/articles/Articles.jsx";

function App() {
  return (
    <>
      <Header />
      <main className='main'>
        <Home />
        <About />
        <Skills />
        <Projects />
        {/*<Qualifications />*/}
        <Articles />
        <Contact />
      </main>
      <Footer />
      <Scroll />
    </>
  );
}

export default App;
